import { RETURN_URL_KEY } from 'app/components/routes';
import { useAuth } from 'context';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function PublicRoute() {
  const { isAuthenticated } = useAuth();
  const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);

  if (isAuthenticated) {
    const targetUrl = returnUrl || '/equipment?askNotificationPermission';

    if (returnUrl) {
      sessionStorage.removeItem(RETURN_URL_KEY);
    }

    return <Navigate to={targetUrl} replace />;
  }

  return <Outlet />;
}
